// extracted by mini-css-extract-plugin
export default {"ZccNotification":"ZccNotificationLight__ZccNotification___h7Gc3"};